export const getUniqueCarriers = (segments) => {
    const carriers = new Map();
    for (const segment of segments) {
        for (const leg of segment.legs) {
            for (const carrier of leg.carriersData) {
                carriers.set(carrier.code, carrier);
            }
        }
    }
    return Array.from(carriers.values());
};
export const getUniqueCarrierCodes = (segments) => getUniqueCarriers(segments).map((c) => c.code);
export const getUniqueMarketingCarriers = (segments) => {
    const carriers = new Map();
    for (const segment of segments) {
        for (const leg of segment.legs) {
            const marketingCarrier = leg.flightInfo?.carrierInfo?.marketingCarrier;
            if (!marketingCarrier || carriers.has(marketingCarrier))
                continue;
            for (const carrier of leg.carriersData) {
                if (carrier.code === marketingCarrier)
                    carriers.set(carrier.code, carrier);
            }
        }
    }
    return Array.from(carriers.values());
};
export const getUniqueMarketingCarrierCodes = (segments) => getUniqueMarketingCarriers(segments).map((c) => c.code);
export const hasMarketingCarrier = (segments, airlines) => segments.some((s) => s.legs.some((l) => airlines.includes(l.flightInfo?.carrierInfo?.marketingCarrier || "")));
export const hasAnyCarrier = (segments, airline) => segments.some((s) => s.legs.some((l) => l.carriers.includes(airline)));
